import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import { AssistantProvider } from "../pages/assistant/AssistantContext";
import { AssistantDock } from "../pages/assistant/Assistant";
import "../styles/hoc/Layout.css";
import { DraftsProvider } from "../context/drafts/DraftsContext";
import { WorkspaceProvider, WorkspaceTaskbar, useWorkspace } from "../context/workspace/WorkspaceContext";

const Shell = ({ children, setValidRoutes, onLogout, isMinimized, onSidebarToggle, isHomePage }) => {
  const hasTaskbar = Boolean(useWorkspace()?.windows.length);
  return (
    <div className={`app-container ${hasTaskbar ? "has-taskbar" : ""}`}>
      <Sidebar
        onToggle={onSidebarToggle}
        setValidRoutes={setValidRoutes}
        onLogout={onLogout}
      />
      <div
        className={`content-wrapper ${isMinimized ? "sidebar-minimized" : ""}`}
      >
        <Header />
        <main className="main-content">
          <div
            className={`main-content-inner ${isHomePage ? "main-content-inner-home" : ""}`}
          >
            {children}
          </div>
        </main>
        <Footer isFixedOnHome={isHomePage} />
      </div>
      <WorkspaceTaskbar sidebarMinimized={isMinimized} />
      <AssistantDock />
    </div>
  );
};

const Layout = ({ children, setValidRoutes, onLogout }) => {
  const [isMinimized, setIsMinimized] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const handleSidebarToggle = (minimized) => {
    setIsMinimized(minimized);
  };

  return (
    <AssistantProvider>
    <WorkspaceProvider>
    <DraftsProvider sidebarMinimized={isMinimized}>
      <Shell setValidRoutes={setValidRoutes} onLogout={onLogout} isMinimized={isMinimized} onSidebarToggle={handleSidebarToggle} isHomePage={isHomePage}>
        {children}
      </Shell>
    </DraftsProvider>
    </WorkspaceProvider>
    </AssistantProvider>
  );
};

export default Layout;
